import { render, staticRenderFns } from "./editar-rol.vue?vue&type=template&id=178aa634&scoped=true&"
import script from "./editar-rol.vue?vue&type=script&lang=js&"
export * from "./editar-rol.vue?vue&type=script&lang=js&"
import style0 from "./editar-rol.vue?vue&type=style&index=0&id=178aa634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178aa634",
  null
  
)

export default component.exports